/**
 * NewsletterModal.js
 */

import $ from 'jquery';

class NewsletterModal {
    constructor() {
        var delayTime = parseInt($('[data-display-newsletter]').data('delay-time'), 10);

        if (sessionStorage.getItem('newsletterModalClosed') === 'true') {
            return;
        }

        if ($('[data-display-newsletter]').data('display-newsletter') === 'hide' ) {
            return;
        } else {
            setTimeout(
                function () {
                    $('.newsletter-modal').addClass('active');
                    $('body').addClass('locked');
                }
                , delayTime);
        }
        this.closePopUp();
    }

    closePopUp() {
        if ($('.modal-close--newsletter')) {
            $('.modal-close--newsletter').on('click', function () {
                $('.newsletter-modal').removeClass('active');
                $('body').removeClass('locked');

                sessionStorage.setItem('newsletterModalClosed', 'true');
            })
        }
        if ($('.js-modal-overlay')) {
            $('.js-modal-overlay').on('click', function () {
                $('.newsletter-modal').removeClass('active');
                $('body').removeClass('locked');

                sessionStorage.setItem('newsletterModalClosed', 'true');
            })
        }
    }
}

new NewsletterModal();